$(document).ready(function () {

    // Slider zweispaltig
    const slidersHalf = document.querySelectorAll(".SwiperSliderHalf");

    if (slidersHalf.length) {
      slidersHalf.forEach((swiperContainer) => {
        const swiperControlId = swiperContainer.getAttribute("data-swiper-id");
        const swiperControls = document.querySelector(
          `.SwiperMeta[data-swiper-id="${swiperControlId}"]`
        );

        const navigationPrev = swiperControls.querySelector(".swiperArrowPrev");
        const navigationNext = swiperControls.querySelector(".swiperArrowNext");
        const scrollbarEl = swiperControls.querySelector('.swiper-scrollbar');

        const swiperInstance = new Swiper(swiperContainer, {
          spaceBetween: 30,
          resizeObserver: true,
          navigation: {
            prevEl: navigationPrev,
            nextEl: navigationNext,
          },
            scrollbar: {
            el: scrollbarEl,
            draggable: true,
          },
          updateOnWindowResize: true,
          breakpoints: {
            0: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            400: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            560: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            768: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
          },
        });
      });
    }

    // Slider vierspaltig
    
    const slidersFull = document.querySelectorAll(".SwiperSliderFull");

    if (slidersFull.length) {
      slidersFull.forEach((swiperContainer) => {
        const swiperControlId = swiperContainer.getAttribute("data-swiper-id");
        const swiperControls = document.querySelector(
          `.SwiperMeta[data-swiper-id="${swiperControlId}"]`
        );

        const navigationPrev = swiperControls.querySelector(".swiperArrowPrev");
        const navigationNext = swiperControls.querySelector(".swiperArrowNext");
        const scrollbarEl = swiperControls.querySelector('.swiper-scrollbar');

        const swiperInstance = new Swiper(swiperContainer, {
          spaceBetween: 15,
          resizeObserver: true,
          navigation: {
            prevEl: navigationPrev,
            nextEl: navigationNext,
          },
            scrollbar: {
            el: scrollbarEl,
            draggable: true,
          },
          updateOnWindowResize: true,
          breakpoints: {
            0: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 15,
            },
            400: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 15,
            },
            650: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: 3,
              slidesPerGroup: 3,
              spaceBetween: 25,
            },
            1200: {
              spaceBetween: 35,
              slidesPerView: 4,
              slidesPerGroup: 4,
            },
          },
        });
      });
    }


});